import { call } from 'redux-saga/effects';
import ServletServices from 'services/ServletServices';

export const servletActions = {
  countContactInGroupByInteraction: 'countContactInGroupByInteraction',
};

export default {
  [servletActions.countContactInGroupByInteraction]: {
    saga: function*({ payload }) {
      const { params = {}, callbacks } = payload;
      try {
        const response = yield call(ServletServices.countContactInGroupByInteraction, params);
        callbacks && callbacks.onSuccess(response);
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
};
